import { type PropsWithChildren } from 'react';
import { meta } from '../../../constants';
import { CustomMetadataFetchersContext } from './CustomMetadataFetchersContext';
import { RadioPlayerCustomMetadataFetchersProvider } from './RadioPlayerCustomMetadataFetchersProvider';

const { alias } = meta;

export function CustomMetadataFetchersProvider({
  children
}: PropsWithChildren) {
  if (alias === 'radio-player') {
    return (
      <RadioPlayerCustomMetadataFetchersProvider>
        {children}
      </RadioPlayerCustomMetadataFetchersProvider>
    );
  }

  return (
    <CustomMetadataFetchersContext.Provider
      value={{ customMetadataFetchers: {} }}
    >
      {children}
    </CustomMetadataFetchersContext.Provider>
  );
}
